// Updated 1/20/2022

const decklists = [
    // Swordcraft
    'Rally Sword',
    'Dionne Sword',
    'Gold Kage OTK Sword',

    // Forestcraft
    'Roach Forest',

    // Runecraft
    'Earth Rite Rune',
    'Spellboost Rune',
    'Storm Rune',

    // Dragoncraft
    'Natura Dragon',
    'Buff Dragon',
    'Face Dragon',

    // Shadowcraft
    'Atomy Shadow',

    // Bloodcraft
    'Wrath Blood',
    'Evo Blood',

    // Havencraft
    'Natura Summit Haven',
    'Jatelent Haven',
    'Kel Haven',

    // Portalcraft
    'Artifact Portal'
]

export default decklists